import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Category = lazy(() => import('./Category.jsx'))

const CategoryRoutes = [
    {
        path: '/Category',
        component: Category,
        auth: authRoleAccess.case_category,
    },
   
]

export default CategoryRoutes 